/**
 * Crawlable service URLs for footer and homepage fallbacks when CMS APIs are unavailable (e.g. prerender build).
 * When adding or renaming a service page, also update public/llms.txt and public/sitemap.xml.
 */

export const FOOTER_EXPERIENCE_LINKS = [
  { label: "Private Yacht Charters", href: "/private-yacht-charter-mumbai-goa" },
  { label: "Yacht Parties", href: "/yacht-party-mumbai" },
  { label: "Speed Boat Transfers", href: "/speedboat" },
  { label: "Browse Packages", href: "/packages" },
  { label: "Corporate Events", href: "/corporate-events" },
  { label: "Corporate Sailing Regattas", href: "/corporate-sailing-regatta-mumbai" },
  {
    label: "Birthday & Anniversary Celebrations",
    href: "/birthday-anniversary-yacht-celebration-mumbai",
  },
  {
    label: "Pre-Wedding Yacht Photo Shoots",
    href: "/pre-wedding-yacht-photoshoot-mumbai",
  },
  {
    label: "Family & Private Yacht Parties",
    href: "/family-private-yacht-party-mumbai",
  },
  {
    label: "Alibaug & Elephanta Boat Tours",
    href: "/alibaug-elephanta-boat-tours-mumbai",
  },
];

export const DEFAULT_SIGNATURE_EXPERIENCE = {
  sectionTitle: "Signature Experiences",
  video: "/assets/img/hero/hero-video.mp4",
  pillars: [
    {
      title: "Private Yacht Charters",
      desc: "Just You, Your Favorite People, and the Open Sea..",
      capacity: "Up to 15 Guests",
      icon: "Anchor",
      id: "01",
      image: "assets/img/img2.png",
      pagename: "private-yacht-charter-mumbai-goa",
    },
    {
      title: "Yacht  Parties",
      desc: "The Ultimate Venue for Grand Celebrations and Floating Events.",
      capacity: "15+ Guests",
      icon: "Waves",
      id: "02",
      image: "assets/img/img3.png",
      pagename: "yacht-party-mumbai",
    },
    {
      title: "Speedboat Transfers",
      desc: "Swift, Private, and Seamless Connectivity to Mandwa & Elephanta",
      capacity: "Quick & Efficient",
      icon: "Zap",
      id: "03",
      image: "assets/img/img4.png",
      pagename: "speedboat",
    },
    {
      title: "Corporate Sailing & Events",
      desc: "Boost Morale with Regattas and Elite Business Networking.",
      capacity: "Custom corporate, B2B and B2C solutions",
      icon: "Users",
      id: "04",
      image: "assets/img/img1.png",
      pagename: "corporate-events",
    },
  ],
};

const DEFAULT_MOST_LOVED_CARDS = [
  {
    id: "01",
    title: "Birthday & Anniversary Yacht Celebrations",
    tagline:
      "Celebrate life’s special moments on a private yacht with stunning sea views, personalized setups and unforgettable memories on the water.",
    desc: "Cake, music, and the ocean breeze.",
    image: "assets/img/birthday-card.jpeg",
    pagename: "birthday-anniversary-yacht-celebration-mumbai",
    buttonText: "Explore Service",
  },
  {
    id: "02",
    title: "Pre-Wedding Yacht Photo Shoots",
    tagline:
      "Capture your love story with a breathtaking ocean backdrop, elegant yacht settings and timeless moments you’ll cherish forever.",
    desc: "Stunning photos and romantic views you'll keep forever.",
    image: "assets/img/pre-wedding-photo.jpeg",
    pagename: "pre-wedding-yacht-photoshoot-mumbai",
    buttonText: "Explore Service",
  },
  {
    id: "03",
    title: "Family & Private Yacht Party Experiences",
    tagline:
      "Enjoy quality time with your loved ones on a private yacht, away from the crowds, with comfort, privacy and beautiful sea views.",
    desc: "No crowds. No noise. Just you and your loved ones.",
    image: "assets/img/family-party.jpeg",
    pagename: "family-private-yacht-party-mumbai",
    buttonText: "Explore Service",
  },
  {
    id: "04",
    title: "Corporate Sailing Regattas",
    tagline:
      "Build teamwork, leadership and communication through an exciting on-water experience designed for corporate teams and business groups.",
    desc: "A fun, competitive way to bond outside the office.",
    image: "assets/img/corporate-regatta.jpeg",
    pagename: "corporate-sailing-regatta-mumbai",
    buttonText: "Explore Service",
  },
  {
    id: "05",
    title: "Corporate Yacht Events & Networking",
    tagline:
      "Impress clients, partners and teams with a distinctive business event experience on the water.",
    desc: "The ultimate 'power move' for meetings and business mixers.",
    image: "assets/img/testBoat.png",
    pagename: "corporate-events-networking-yacht-mumbai",
    buttonText: "Explore Service",
  },
  {
    id: "06",
    title: "Alibaug & Elephanta Boat Tours",
    tagline:
      "Escape the city with quick island getaways and scenic boat experiences from Mumbai to Alibaug and Elephanta.",
    desc: "Skip the traffic. Explore Mumbai’s best islands in style.",
    image: "assets/img/alibaug-elephanta.jpeg",
    pagename: "alibaug-elephanta-boat-tours-mumbai",
    buttonText: "Explore Service",
  },
];

export const DEFAULT_MOST_LOVED_EXPERIENCES = {
  badge: "Guest Favorites",
  mainTitle: "Most Loved",
  accentTitle: "Experiences",
  subtitle:
    "Curated yacht and boat experiences our guests book again and again across Mumbai and Goa.",
  cards: DEFAULT_MOST_LOVED_CARDS,
};
